
























































import { Component, Prop, Vue, Provide } from 'vue-property-decorator';

import ErrorWrappedTextInput from '@/components/form-elements/ErrorWrappedTextInput.vue';
import AbstractAddItem_Step2 from '@/components/add-flows/AbstractAddItem-Step2.vue';
import { UploadUtils } from '@/utils/upload-utils';
import { ItemModelUtil } from '@/model-utils/item-model-util';
import { UserModule } from '@/store/modules/user';
import { ListModel } from '@/models/list-model';
import { GenericItem } from '@/models/items/generic-item-model';

@Component({
  components: { ErrorWrappedTextInput }
})
export default class InlineAddItem extends AbstractAddItem_Step2 {
  @Prop(Array) public urlImages: string[];
  @Prop(String) public title: string;
  @Prop(String) public description: string;

  @Prop(ListModel) public list: ListModel;

  created() {
    console.log(this.urlImages);
    this.images = this.images.concat(this.urlImages);
    if (this.images.length > 0) {
      this.setSelectedImage(this.images[0]);
    }
    this.item.title = this.title;
    this.item.description = this.description;
  }

  public async onSubmit() {
    console.log('calling my onsubmit');
    const isValid = (await this.$validator.validate()) && this.isFormValid();

    if (isValid) {
      if (
        this.item.imageURL &&
        !UploadUtils.isUploadedImage(this.item.imageURL)
      ) {
        const imageURL = await UploadUtils.uploadImageToFirebaseFromUrl(
          this.item.imageURL
        );
        this.item.imageURL = imageURL;
      }

      ItemModelUtil.addItemToList(
        this.item,
        this.list,
        UserModule.userProfile
      ).then(() => this.$emit('item-saved'));
    } else {
      console.log('not valid');
    }
  }

  public onCancel() {
    this.$emit('cancel');
  }
}
